/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import { routerActions } from 'react-router-redux';
import {
  Editor,
  EditorState,
  ContentState,
} from 'draft-js';
import Editable from 'loracoms/Editable';
import ShowIf from 'loracoms/ShowIf';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { callAPI } from 'lorautils/api';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ParserDelModal from '../ParserDelModal';
import styles from './styles.scss';


const propTypes = {
  parser: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  appId: React.PropTypes.string.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class ParserCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      parser: props.parser,
      errors: ErrorSet.createEmpty(),
      descState: EditorState.createEmpty(),
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.parsers');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDesc = this.handleChangeDesc.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { parser } = nextProps;
    if (parser !== this.props.parser) {
      this.setState({ parser });
    }
  }

  handleChange(editData, id) {
    const { errors } = this.state;
    this.setState({ editData });
    if (id === 'name') {
      if (editData.name === '') {
        this.setState({
          errors: errors.add('FE_EMPTY', 'name'),
        });
      } else {
        this.setState({
          errors: errors.remove('name'),
        });
      }
    }
  }

  handleChangeDesc(descState) {
    this.setState({ descState });
  }

  handleEdit() {
    const { parser: { name, desc }, errors } = this.state;
    this.setState({
      edit: true,
      editData: { name },
      descState: (
        EditorState.createWithContent(
          ContentState.createFromText(desc))),
      errors: errors.remove('name'),
    });
  }

  handleSubmit() {
    const { editData: { name }, descState, errors, parser } = this.state;
    if (errors.has('name')) {
      return;
    }

    const desc = descState.getCurrentContent().getPlainText();
    callAPI({
      endpoint: `/lora/parsers/${parser.id}`,
      body: { name, desc },
      method: 'PUT',
    }).then(() => {
      this.setState({
        parser: {
          ...parser,
          name,
          desc,
        },
        edit: false,
      });
    }).catch((error) => {
      this.setState({
        errors: errors.add(error.code, 'name'),
      });
    });
  }

  render() {
    const { pushState, appId } = this.props;
    const {
      parser,
      showDelete = false,
      edit = false,
      editData = {},
      errors,
      descState,
    } = this.state;
    return (
      <div className={styles.card}>
        <div className={styles.name}>
          <Editable
            id="name"
            edit={edit}
            value={parser.name}
            data={editData}
            formatter={x => (
              <Link onClick={() => pushState(`/application/${appId}/parse/${parser.id}`)}>
                {x}
              </Link>
            )}
            onChange={this.handleChange}
            error={this.intlMsg.errorMsg(errors.get('name'))}
          />
        </div>
        <div className={styles.desc}>
          <Editable
            id="desc"
            edit={edit}
            value={parser.desc}
            data={editData}
            control={{
              type: 'external',
              external: (
                <div className={styles.descEditor}>
                  <Editor
                    editorState={descState}
                    onChange={this.handleChangeDesc}
                  />
                </div>
              ),
            }}
            formatter={(x) => {
              if (x.length < 40) { return <span>{x}</span>; }
              return <span>{`${x.substring(0, 40)}...`}</span>;
            }}
          />
        </div>
        <ShowIf if={!edit}>
          <div className={styles.actions}>
            <Link
              className={styles.delete}
              onClick={() => this.setState({ showDelete: true })}
            >
              <span className="glyphicons glyphicons-remove-sign" />
            </Link>
            <Link
              className={styles.edit}
              onClick={this.handleEdit}
            >
              <span className="glyphicons glyphicons-pencil" />
            </Link>
          </div>
        </ShowIf>
        <ShowIf if={edit}>
          <div className={styles.actions}>
            <Link className={styles.ok} onClick={this.handleSubmit}>
              <span className="glyphicons glyphicons-ok" />
            </Link>
            <Link className={styles.cancel} onClick={() => this.setState({ edit: false })}>
              <span className="glyphicons glyphicons-remove" />
            </Link>
          </div>
        </ShowIf>
        <ParserDelModal
          appId={appId}
          parser={parser}
          show={showDelete}
          onHide={() => this.setState({ showDelete: false })}
        />
      </div>
    );
  }
}

ParserCard.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null, mapDispatchToProps)(injectIntl(ParserCard));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserCard/index.jsx